module.exports = __webpack_public_path__ + "img/IMG_20200821_142940.f07a8825.f07a8825.jpg";